import React, { useState, useRef, useMemo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { nameregex, priceRegex } from "../helper/regex";
import { API_BASE_URL, API_PATHS } from "../utils/constants/api.constants";
import JoditEditor from "jodit-react";
import { getPlaceList } from "../store/slices/places";
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { GrUploadOption } from "react-icons/gr";
import { postcarrentalPackage } from "../store/slices/carrentalpackage";
import { getcarTypeRange, getcarType } from "../store/slices/carType";

const DEFAULT_DESCRIPTION = `

<p>
We offer a wide range of vehicle classes that suit every travel requirement—whether you are traveling solo, with family, or in a group.
</p>

<p>
If you have booked your hotel directly through an online platform or special offers and are now worried about airport pick-up & drop,
local sightseeing in Port Blair, harbor transfers, island sightseeing for Havelock & Neil Island, ferry/cruise tickets,
or complete logistical support—leave all your worries to us.
</p>

<h6>Service Locations</h6>
<ul>
  <li>Port Blair</li>
  <li>Havelock Island</li>
  <li>Neil Island</li>
  <li>Baratang</li>
  <li>Rangat, Mayabunder & Diglipur</li>
</ul>

<h6>Our Services Include</h6>
<ul>
  <li>Local Hourly Car Rentals</li>
  <li>Airport Pick-up & Drop</li>
  <li>Sightseeing Tours</li>
  <li>Ferry / Boat Ticket Assistance</li>
  <li>Forest Permit & Entry Ticket Arrangement</li>
</ul>

<p>
Book with us and enjoy a completely hassle-free holiday experience in the Andaman Islands.
</p>
`;

const AddCarRentalPackage = () => {
  const editor = useRef(null);
  let user = JSON.parse(localStorage.getItem("users"));
  const token = user.data.accessToken;
  const [packageErrors, setpackageErrors] = useState([]);
  const [itineraryErrors, setItineraryErrors] = useState([]);
  const [duration, setDuration] = useState("");
  const [places, setPlaces] = useState([]);
  const [placeList, setplaceList] = useState([]);
  const [packageName, setpackageName] = useState("");
  const [description, setDescription] = useState(DEFAULT_DESCRIPTION);
  const [images, setImages] = useState([]);
  const [imageError, setImageError] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [range, setRange] = useState([]);

  const stripHtmlTags = (html) => {
    return html.replace(/<[^>]*>/g, "").trim();
  };

  React.useEffect(() => {
    dispatch(getcarTypeRange())
      .unwrap()
      .then((data) => {
        setRange(data?.ranges);
      })
      .catch((err) => {
        console.error("Error fetching category:", err.message);
      });
  }, [dispatch]);

  const [packages, setpackages] = useState([
    {
      id: Date.now(),
      vehicleName: "",
      price: "",
      entryFees: "",
      range: "",
    },
  ]);

  const [iternary, setIternary] = useState([
    {
      id: Date.now(),
      title: "",
      timing: "",
      description: "",
    },
  ]);

  const handleAddItinerary = (e) => {
    e.preventDefault();

    setIternary([
      ...iternary,
      {
        id: Date.now(),
        title: "",
        description: "",
        timing: "",
      },
    ]);

    setItineraryErrors([
      ...itineraryErrors,
      {
        title: "",
        timing: "",
        description: "",
      },
    ]);
  };

  const handleRemoveItinerary = (id) => {
    const updatedItinerary = iternary.filter((q) => q.id !== id);
    setIternary(updatedItinerary);

    const updatedErrors = itineraryErrors.filter(
      (_, index) => iternary[index].id !== id,
    );
    setItineraryErrors(updatedErrors);
  };

  const handleAddpackage = (e) => {
    e.preventDefault();

    setpackages([
      ...packages,
      {
        id: Date.now(),
        vehicleName: "",
        range: "",
        price: "",
        entryFees: "",
      },
    ]);

    setpackageErrors([
      ...packageErrors,
      {
        vehicleName: "",
        range: "",
        price: "",
        entryFees: "",
      },
    ]);
  };

  const handleRemovepackage = (id) => {
    const updatedpackage = packages.filter((q) => q.id !== id);
    setpackages(updatedpackage);

    const updatedErrors = packageErrors.filter(
      (_, index) => packages[index].id !== id,
    );
    setpackageErrors(updatedErrors);
  };

  const handleInputChange = async (index, field, value) => {
    const updatedPackages = [...packages];
    const updatedErrors = [...packageErrors];

    if (!updatedErrors[index]) {
      updatedErrors[index] = {
        vehicleName: "",
        range: "",
        price: "",
        entryFees: "",
      };
    }

    if (field === "range") {
      updatedPackages[index][field] = value;

      // Count occurrences of each selected range
      const rangeCounts = updatedPackages.reduce((acc, item) => {
        if (item.range) {
          acc[item.range] = (acc[item.range] || 0) + 1;
        }
        return acc;
      }, {});

      // Set errors for duplicate ranges
      updatedErrors.forEach((error, idx) => {
        error.range =
          rangeCounts[updatedPackages[idx].range] > 1
            ? "Duplicate range selected"
            : updatedPackages[idx].range.trim() === ""
              ? "Please select a range"
              : "";
      });

      try {
        const carData = await dispatch(getcarType({ range: value })).unwrap();
        updatedPackages[index].carOptions = carData?.carData || [];
      } catch (error) {
        console.error("Error fetching car list:", error.message);
        updatedPackages[index].carOptions = [];
      }
    }

    if (field === "vehicleName") {
      updatedPackages[index][field] = value;
      updatedErrors[index].vehicleName =
        value.trim() === "" ? "Please select a vehicle" : "";
    }

    if (field === "price") {
      var sanitizedPrice = value.replace(/\D/g, "").slice(0, 5);
      updatedPackages[index][field] = sanitizedPrice;
      updatedErrors[index].price =
        sanitizedPrice === "" || !priceRegex.test(sanitizedPrice)
          ? "Please enter a valid price"
          : "";
    }

    if (field === "entryFees") {
      var sanitizedEntryFees = value.replace(/\D/g, "").slice(0, 5);
      updatedPackages[index][field] = sanitizedEntryFees;
      updatedErrors[index].entryFees =
        sanitizedEntryFees === "" || !priceRegex.test(sanitizedEntryFees)
          ? "Please enter valid entry fees"
          : "";
    }

    setpackageErrors([...updatedErrors]); // Ensure state updates
    setpackages([...updatedPackages]);
  };

  const handleiterInputChange = (index, field, value) => {
    const updatedItinerary = [...iternary];
    updatedItinerary[index][field] = value;
    setIternary(updatedItinerary);
    const updatedErrors = [...itineraryErrors];
    if (!updatedErrors[index]) {
      updatedErrors[index] = { title: "", description: "", timing: "" };
    }

    if (field === "title") {
      updatedErrors[index].title =
        value.trim() === "" ? "Please enter title" : "";
    }

    if (field === "description") {
      updatedErrors[index].description =
        value.trim() === "" ? "Please enter description" : "";
    }

    setItineraryErrors(updatedErrors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    switch (name) {
      case "packageName":
        setpackageName(value);
        validationErrors[name] =
          value.trim() === "" || !nameregex.test(value)
            ? "Please enter valid package name"
            : "";
        break;

      case "duration":
        setDuration(value);
        validationErrors[name] =
          value.trim() === "" ? "Please enter duration" : "";
        break;

      case "description":
        setDescription(value);
        if (errors.description && stripHtmlTags(value).length > 0) {
          setErrors((prevErrors) => ({ ...prevErrors, description: "" }));
        }
        break;

      default:
        setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        break;
    }

    setErrors(validationErrors);
  };

  const handlePlaceChange = (selectedOptions) => {
    const selectedPlaces = selectedOptions.map((option) => ({
      placeId: option._id,
      name: option.name,
    }));
    setPlaces(selectedPlaces);
    const isValid = selectedPlaces.length > 0;
    setErrors((prevErrors) => ({
      ...prevErrors,
      places: isValid ? "" : "Please select at least one place",
    }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!packageName.trim()) {
      newErrors.packageName = "Please enter package name";
    } else if (!nameregex.test(packageName)) {
      newErrors.packageName = "Please enter valid package name";
    }

    // Places Validation
    if (places.length === 0) {
      newErrors.places = "Please select at least one place";
    }

    // Other Text Field Validations
    if (!description.trim() || stripHtmlTags(description).length === 0) {
      newErrors.description = "Please enter description";
    }

    // Image Validation
    if (images.length === 0) {
      newErrors.imageError = "Please upload at least one image";
      setImageError("Please upload at least one image");
    } else {
      setImageError(""); // Clear error if images exist
    }

    // Duration and Upper Limit Validation
    if (!duration) {
      newErrors.duration = "Please enter duration";
    }

    const rangeCounts = packages.reduce((acc, item) => {
      if (item.range) {
        acc[item.range] = (acc[item.range] || 0) + 1;
      }
      return acc;
    }, {});

    // package Validation
    const packageErrors = packages.map((item) => ({
      vehicleName:
        item.vehicleName.trim() === "" ? "Please select vehicle" : "",
      price: item.price.trim() === "" ? "Please enter price" : "",
      entryFees: item.entryFees.trim() === "" ? "Please enter entry fees" : "",
      range:
        item.range.trim() === ""
          ? "Please select a range"
          : rangeCounts[item.range] > 1
            ? "Duplicate range selected"
            : "",
    }));
    setpackageErrors(packageErrors);

    // Check for any package errors
    if (
      packageErrors.some((err) => err.title || err.description || err.range)
    ) {
      newErrors.tourIternary = "Please fix errors in the package section";
    }
    const itineraryErrors = iternary.map((item) => ({
      title: item.title.trim() === "" ? "Please enter title" : "",
      description:
        item.description.trim() === "" ? "Please enter description" : "",
    }));
    setItineraryErrors(itineraryErrors);

    if (itineraryErrors.some((err) => err.title || err.description)) {
      newErrors.iternary = "Please fix errors in the itinerary section";
    }

    // Finally set all errors in the state
    setErrors(newErrors);

    const isValid =
      Object.keys(newErrors).length === 0 &&
      packageErrors.every((err) => !err.title && !err.description);

    return isValid;
  };
  const addPackage = async (e) => {
    e.preventDefault();
    setIsDisabled(true);

    setTimeout(() => setIsDisabled(false), 3000);

    if (!validateForm()) {
      console.log("Validation failed, please fix the errors.", errors);
      setIsDisabled(false);
      return;
    }

    const item = {
      packageName,
      duration,
      isActive: 1,
      isApproved: 1,
      packages,
      iternary,
      isSpecial: 0,
      places,
      description,
      images: images,
    };
    console.log(item);

    try {
      await dispatch(postcarrentalPackage(item)).unwrap();
      alert("Package added successfully!");
      navigate("/admin/carrental");
    } catch (error) {
      alert(error);
      setIsDisabled(false);
    }
  };

  function cancel(e) {
    navigate(-1);
  }

  const imageUpload = async (e) => {
    setImageError("");
    const files = Array.from(e.target.files);

    if (files.length === 0) {
      setImageError("Please select at least one file to upload");
      return;
    }
    if (images.length + files.length > 10) {
      setImageError("You can upload a maximum 10 images");
      return;
    }

    const newImage = [];
    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        setImageError("Please upload image less than 5 MB");
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      const requestOptions = {
        method: "POST",
        body: formData,
        headers: {
          "x-access-token": token,
        },
      };

      try {
        const response = await fetch(
          `${API_BASE_URL}${API_PATHS.uploadFile}`,
          requestOptions,
        );

        if (!response.ok) {
          throw new Error(`Upload failed with status: ${response.status}`);
        }

        const data = await response.json();

        if (data?.status === 1 && data?.data?.location) {
          newImage.push({
            name: file.name,
            mediaLink: data.data.location,
            isActive: true,
          });
        } else {
          throw new Error(data.message || "Failed to upload image");
        }
      } catch (error) {
        setImageError(
          error.message || "Something went wrong while uploading the image",
        );
        return;
      }
    }

    setImages((prevImage) => [...prevImage, ...newImage]);
    if (newImage.length === 0) {
      setImageError("Image upload failed. Please try again.");
    }
    e.target.value = null;
  };

  useEffect(() => {
    console.log("Updated images state:", images);
  }, [images]);

  const removeImage = (index) => {
    setImages((prevImage) => {
      const updatedImage = [...prevImage];
      updatedImage.splice(index, 1);

      if (updatedImage.length === 0) {
        setImageError("Please upload at least one image");
      } else {
        setImageError("");
      }

      return updatedImage;
    });
  };

  const editorConfig = useMemo(
    () => ({
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "|",
        "align",
        "font",
        "fontsize",
        "paragraph",
        "|",
        "undo",
        "redo",
      ],
      placeholder: "Enter Description",
      removeButtons: ["image", "video", "file", "speech", "print", "preview"],
      readonly: false,
    }),
    [],
  );

  const itineraryEditorConfig = useMemo(
    () => ({
      height: 180,
      toolbarAdaptive: false,
      buttons: ["bold", "italic", "|", "ul", "ol", "|", "undo", "redo"],
      placeholder: "Enter itinerary details",
      removeButtons: [
        "image",
        "video",
        "file",
        "speech",
        "print",
        "preview",
        "fontsize",
        "font",
      ],
    }),
    [],
  );

  React.useEffect(() => {
    dispatch(getPlaceList())
      .unwrap()
      .then((data) => {
        setplaceList(data?.placesData || []);
      })
      .catch((err) => {
        console.error("Error fetching places:", err.message);
      });
  }, [dispatch]);

  return (
    <>
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Add Package</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/tour-package"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Packages
            </Link>
          </li>
          <li> &gt; </li>
          <li className="fw-medium">Add Package</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-body p-24">
          <form autoComplete="off" onSubmit={addPackage}>
            <div className="row mb-40">
              <div className="col-md-5">
                <label className="form-label">
                  Package Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="packageName"
                  value={packageName}
                  maxLength={150}
                  onChange={handleChange}
                  className={`form-control ${
                    errors.packageName ? "is-invalid" : ""
                  }`}
                  placeholder="Enter Package Name"
                />
                {errors.packageName && (
                  <div className="text-danger mt-2">{errors.packageName}</div>
                )}
              </div>

              <div className="col-md-5">
                <label className="form-label">
                  Duration <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="duration"
                  value={duration}
                  onChange={handleChange}
                  placeholder="Enter duration"
                  className={`form-control ${
                    errors.duration ? "is-invalid" : ""
                  }`}
                />

                {errors.duration && (
                  <div className="text-danger mt-2">{errors.duration}</div>
                )}
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Places<span className="text-danger">*</span>
                </label>
                <Typeahead
                  id="basic-typeahead-multiple"
                  labelKey="name"
                  multiple
                  className="input1"
                  onChange={handlePlaceChange}
                  options={placeList}
                  placeholder="Select Places"
                  selected={placeList.filter((place) =>
                    places.some(
                      (selectedPlace) => selectedPlace.placeId === place._id,
                    ),
                  )}
                />
                {errors.places && (
                  <div className="text-danger mt-2">{errors.places}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Images <span className="text-danger">*</span>
                </label>
                <br />
                <label for="fileInput" className="custom-button">
                  <GrUploadOption
                    style={{ fontSize: "16px", lineHeight: "18px" }}
                  />
                  &nbsp; Upload Image
                </label>
                <input
                  type="file"
                  id="fileInput"
                  name="image"
                  accept="image/*"
                  onChange={imageUpload}
                  className={`form-control ${imageError ? "is-invalid" : ""}`}
                  multiple
                />

                {imageError && (
                  <div className="text-danger mt-2">{imageError}</div>
                )}
                <div className="row mt-3">
                  {images.map((img, index) => (
                    <div
                      className="col-md-2 mb-2 position-relative"
                      key={index}
                    >
                      <img
                        src={img.mediaLink}
                        style={{ height: "120px", objectFit: "cover" }}
                        alt=""
                        className="img-thumbnail"
                      />
                      <button
                        className="image-remove-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          removeImage(index);
                        }}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Description <span className="text-danger">*</span>
                </label>

                <JoditEditor
                  ref={editor}
                  value={description}
                  onChange={(newContent) => {
                    setDescription(newContent);
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      description:
                        !newContent.trim() ||
                        stripHtmlTags(newContent).length === 0
                          ? "Please enter description"
                          : "",
                    }));
                  }}
                  config={editorConfig}
                />

                {errors.description && (
                  <div className="text-danger mt-2">{errors.description}</div>
                )}
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Itinerary <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {iternary.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddItinerary}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemoveItinerary(item.id)}
                          disabled={iternary.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-6">
                          <label className="form-label">
                            Title <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            placeholder="Enter title"
                            value={item.title}
                            onChange={(e) =>
                              handleiterInputChange(
                                index,
                                "title",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {itineraryErrors[index]?.title && (
                            <span className="error-message">
                              {itineraryErrors[index]?.title}
                            </span>
                          )}
                        </div>

                        <div className="col-md-6">
                          <label className="form-label">Timing</label>
                          <input
                            type="text"
                            placeholder="Enter timing"
                            value={item.timing}
                            onChange={(e) =>
                              handleiterInputChange(
                                index,
                                "timing",
                                e.target.value,
                              )
                            }
                            className="form-control"
                          />
                          {itineraryErrors[index]?.timing && (
                            <span className="error-message">
                              {itineraryErrors[index]?.timing}
                            </span>
                          )}
                        </div>

                        <div className="col-md-12 mt-3">
                          <label className="form-label">
                            Details <span className="text-danger">*</span>
                          </label>
                          <JoditEditor
                            value={item.description}
                            config={itineraryEditorConfig}
                            onChange={(newContent) =>
                              handleiterInputChange(
                                index,
                                "description",
                                newContent,
                              )
                            }
                          />

                          {itineraryErrors[index]?.description && (
                            <span className="error-message">
                              {itineraryErrors[index]?.description}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-md-10 mt-3">
                <label className="form-label">
                  Price <span className="text-danger">*</span>
                </label>
                <div className="question-form">
                  {packages.map((item, index) => (
                    <div
                      key={item.id}
                      className="container border p-3 mb-3 rounded"
                    >
                      <div className="d-flex justify-content-end mb-2">
                        <button
                          className="btn btn-primary-600  me-2"
                          onClick={handleAddpackage}
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                        >
                          <CiCirclePlus style={{ fontSize: "25px" }} />
                        </button>
                        <button
                          className="btn btn-outline-primary-600"
                          style={{
                            height: "30px",
                            width: "30px",
                            padding: "0",
                          }}
                          onClick={() => handleRemovepackage(item.id)}
                          disabled={packages.length === 1}
                        >
                          <CiCircleMinus style={{ fontSize: "25px" }} />
                        </button>
                      </div>

                      <div className="row mt-3">
                        <div className="col-md-4 ">
                          <label className="form-label">
                            Members
                            <span className="text-danger">*</span>
                          </label>
                          <select
                            name="range"
                            value={item.range}
                            onChange={(e) =>
                              handleInputChange(index, "range", e.target.value)
                            }
                            className={`form-control ${
                              errors.range ? "is-invalid" : ""
                            }`}
                          >
                            <option value="">Select</option>
                            {range?.map((cardata) => (
                              <option key={cardata.cardata} value={cardata}>
                                {cardata}
                              </option>
                            ))}
                          </select>
                          {packageErrors[index]?.range && (
                            <div className="text-danger ">
                              {packageErrors[index]?.range}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">
                            Vehicle Name <span className="text-danger">*</span>
                          </label>
                          <select
                            name="vehicleName"
                            value={item.vehicleName}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "vehicleName",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              packageErrors[index]?.vehicleName
                                ? "is-invalid"
                                : ""
                            }`}
                          >
                            <option value="">Select Vehicle</option>
                            {item.carOptions?.map((car) => (
                              <option key={car._id} value={car.carName}>
                                {car.carName}
                              </option>
                            ))}
                          </select>
                          {packageErrors[index]?.vehicleName && (
                            <span className="error-message">
                              {packageErrors[index]?.vehicleName}
                            </span>
                          )}
                        </div>

                        <div className="col-md-4">
                          <label className="form-label">
                            Price
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="priceperPerson"
                            value={item.price}
                            onChange={(e) =>
                              handleInputChange(index, "price", e.target.value)
                            }
                            className={`form-control ${
                              packageErrors[index]?.price ? "is-invalid" : ""
                            }`}
                            placeholder="Enter Price"
                          />
                          {packageErrors[index]?.price && (
                            <div className="text-danger mt-2">
                              {packageErrors[index]?.price}
                            </div>
                          )}
                        </div>
                        <div className="col-md-4 mt-3">
                          <label className="form-label">
                            Entry Fees (Per Person)
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            name="priceperChild"
                            value={item.entryFees}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "entryFees",
                                e.target.value,
                              )
                            }
                            className={`form-control ${
                              packageErrors[index]?.entryFees
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Enter Entry Fees"
                          />
                          {packageErrors[index]?.entryFees && (
                            <div className="text-danger mt-2">
                              {packageErrors[index]?.entryFees}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-center gap-3">
              <button
                type="button"
                onClick={cancel}
                className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isDisabled}
                className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCarRentalPackage;
